import React, { useState } from 'react';
import {Table as TablaBoot, Button, input} from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';

function ListadoDetalle (props) {
  //console.log(props.datos)

  if (props.datos.length >= 12) {
    //llego al máximo valor del listado
    props.setListaDetalleCompleta(true);
  } else {
    props.setListaDetalleCompleta(false);
  }

  return (
    <>
      <TablaBoot striped bordered hover >
        <thead>
          <tr>
            <th>
              num_serie
            </th>
            <th>
              i_fuga_1
            </th>
            <th>
              num_parches
            </th>
            <th>
              tensión_ensayo
            </th>
            <th>
              aprobado
            </th>
            <th>
              Acción
            </th>
          </tr>
        </thead>
        <tbody>
          {props.datos.map((detalle) => 
            <tr key={detalle.serie} >
              <td>{detalle.serie}</td>
              <td>{detalle.fuga1}</td>
              <td>{detalle.parches}</td>
              <td>{detalle.tension}</td>
              <td>{detalle.resultado}</td>
              <td> <button onClick={() => {props.borraElementoDetalle(detalle.serie)}} class="btn btn-outline-primary" size="sm"><Trash /></button> </td>
            </tr>
            )}
        </tbody>
      </TablaBoot>
    </>
  )
}

export default ListadoDetalle;